import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Task Checklist Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5"
    }, [
      _createElementVNode("path", { d: "M7.75 3.75h-4a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h16.5a1.5 1.5 0 0 0 1.5-1.5V5.25a1.5 1.5 0 0 0-1.5-1.5h-4" }),
      _createElementVNode("path", { d: "M15.92 4.74a.75.75 0 0 1-.71.51H8.79a.75.75 0 0 1-.71-.51l-1-3a.75.75 0 0 1 .1-.68.77.77 0 0 1 .61-.31h8.42a.77.77 0 0 1 .61.31.75.75 0 0 1 .1.68ZM18.75 6.75v9.88a1.5 1.5 0 0 1-.44 1.06l-2.12 2.12a1.5 1.5 0 0 1-1.06.44H6a.76.76 0 0 1-.75-.75V6.75" }),
      _createElementVNode("path", { d: "M13.75 20.25v-3.5a1.5 1.5 0 0 1 1.5-1.5h3.5" })
    ], -1)
  ])))
}
export default { render: render }